import { setupLdpPageTracking, handleFullLdpAccordionClicks } from 'shared_critical/tracking/pages/ldp/ldp_page_load';
import detectInstantApp from 'shared_critical/instant_app_detection';

function showDisabledCookieInformation() {
  if (navigator.cookieEnabled === false) {
    $('#notification-cookies').removeClass('no-show');
  }
};

function sync_load(first, second) {
  if (first && second) {
    loadScript(first).done(function () {
      loadScript(second);
    });
  }
}

function downloadJSAtOnload(scriptsToLoad) {
  const sync_scripts = [];
  if (scriptsToLoad.length === 1) {
    return loadScript(scriptsToLoad[0]);
  }
  while (scriptsToLoad.length > 0) {
    sync_scripts.push(scriptsToLoad.splice(0, 2));
  }
  $.each(sync_scripts, function (i, v) {
    sync_load(v[0], v[1]);
  });
}

function lazyLoadJs(scriptsToLoad) {
  MOVE.logger.debug('loading', scriptsToLoad);
  var pageType = MOVE.DOMHelper.detectPageType();
  //check to load scripts non lazily for edge browser
  //This is a hack since few specific version(s) of edge browsers
  //are not firing load event.So the only alternate is to depend upon
  //DOMContentLoaded and give time of 300ms and load non critical scripts.
  //Edge should gracefully fix this in near future and we should revert this.
  if (/Edge/.test(navigator.userAgent) && pageType == "srp") {
    window.addEventListener("DOMContentLoaded", function(){
      window.setTimeout(function(){
        lazyScriptsLoad(scriptsToLoad)
      },600);
    });
  }else if ( window.addEventListener ) {
    window.addEventListener("load", function(){lazyScriptsLoad(scriptsToLoad)});
  } 
}

function lazyScriptsLoad(scriptsToLoad){
  downloadJSAtOnload(scriptsToLoad);
  MOVE.CalculatePageLoadTime.init();
}

function setPerformanceDtm() {
  if (MOVE_DATA.adobeDTM) {
    MOVE_DATA.adobeDTM.getPerformance = function() {
      return ({
        timeToLoadStart: getPerformance('navigationStart', 'loadEventStart'),
        timeToLoadEnd: getPerformance('navigationStart', 'loadEventEnd'),
      })
    };
  }
}

function getPerformance(start, end) {
  if (window.performance && window.performance.timing) {
    var time = 0;
    if ( window.performance.timing[end] !== 0 ) {
      time = window.performance.timing[end] - window.performance.timing[start];
    }
    return (
      {
        time: time,
        startEvent: start,
        endEvent: end
      }
    );
  }
}

function init() {
  const pageType = MOVE.DOMHelper.detectPageType();

  if (pageType === 'ldp') {
    setupLdpPageTracking();
    handleFullLdpAccordionClicks();
  }

  setPerformanceDtm();

  MOVE.performanceMark('critical_init_start');

  showDisabledCookieInformation();

  _.forEach(workarounds, function (workaround) {
    workaround.init();
  });

  // Initialize page specific scripts.
  switch (pageType) {
  case 'ldp':
    // Load Building page js if it is builing.
    if(MOVE_DATA.is_building) {
      MOVE.BDP.init();
      MOVE.BDP.Building.init();
    } else {
      MOVE.LDP.init();
      MOVE.LDP.PropertyDetails.init();
    }

    break;
  case 'srp':
    MOVE.SRP.init();
    MOVE.SRP.SearchResults.init();
    break;
  case 'hp':
    MOVE.HOMEPAGE.init();
    MOVE.HOMEPAGE.HomePageSearch.init();
    break;
  case 'local':
    MOVE.LOCAL.init();
    break;
  case 'sell':
    MOVE.SELL.init();
    break;
  case 'property_records':
    MOVE.PropertyRecords.init();
    MOVE.PropertyRecords.page.init();
    break;
  case 'news_and_advice':
    MOVE.ARTICLE.init();
    break;
  default:
    break;
  }

  lazyLoadJs(MOVE.DataStore.getData('app_js'));

  if (MOVE.DataStore.getData('isIosOrAndroid')) {
    MOVE.CustomSmartbanner.init();
  }

  if (MOVE_DATA.isAndroid && ['srp', 'ldp'].indexOf(MOVE_DATA.pageType) >= 0) {
    detectInstantApp(loadScript);
  }

  // initialize the Qualtrics JS only when any of the A/B tests are running
  if($("#qualtrics_feedback").length){
    MOVE.FeedbackForABTests.init();
  }

  /* eslint-disable*/
  //setting Foresee Invite Cookie
  $(window).on('load', function() {
      invokeForseeSnippet();
  });

  function setForeseeCookie() {
      fsReady(function(){
        FSR && FSR.onInviteShown && FSR.onInviteShown.subscribe(
          function() {
            document.cookie = "FS_Survey=true; path=/";
          }, true, true
        );
      });
  }

  function invokeForseeSnippet() {
      setTimeout(() => {
        try{
          setForeseeCookie();
        }
        catch(err){
          console.log(err)
        }
      }, 6000);
  }
  /* eslint-enable */

  MOVE.UserProfileLeadInputs.setLeadInputs();

  MOVE.performanceMark('critical_init_end');
};

function performanceMark(name) {
  if (window.performance && window.performance.mark) {
    window.performance.mark(name);
  }
};

const workarounds = [];
function addWorkaround(module) {
  workarounds.push(module);
};

window.MOVE = {
  site: "renovate",
  addWorkaround: addWorkaround,
  init: init,
  lazyLoadJs: lazyLoadJs,
  performanceMark: performanceMark
};

export const loadScript = function loadScript (url) {
  const loaded = $.Deferred();
  const script = document.createElement("script");
  script.type = "text/javascript";
  if (script.readyState) {  //IE
    script.onreadystatechange = function () {
      if (script.readyState === "loaded" ||
          script.readyState === "complete") {
        script.onreadystatechange = null;
        loaded.resolve(true);
      }
    };
  } else {  //Others
    script.onload = function () {
      loaded.resolve(true);
    };

    script.onerror = (event) => loaded.reject(event);
  }
  script.src = url;
  document.body.appendChild(script);
  return loaded;
};


// WEBPACK FOOTER //
// ./_core_framework/move.js